module.exports = __webpack_public_path__ + "static/media/bannerimg03.9cec4155.jpg";